import Vue from 'vue';

export default (http, vue, store, router) => {
  const services = {};
  Vue.prototype.$services = services;
  let files = require.context('.', false, /.js$/);
  let keys = files.keys();
  keys.forEach((key) => {
    if (key.indexOf('ServiceInject.js') > 0 || key.indexOf('ServiceBase.js') > 0) {
      return;
    }
    let name = key.substring(key.lastIndexOf('/') + 1, key.length - 3);
    let service = files(key).default;
    let instance = service();
    instance.init(http, vue, store, router);
    services[name] = instance;
  });
};
